<template>
  <div class="content">
    <el-form :model="ruleForm" ref="ruleForm" :rules="rules" label-width="100px" class="demo-ruleForm">
        <el-form-item label="代理商：" prop="userId" v-show="adminShow" label-width="170px">
          <el-select v-model="ruleForm.userId" filterable clearable placeholder="代理商" @change="changeAgent($event)">
            <el-option v-for="(item,index) in agentList" :key="index" :label="'['+item.username+']-' + item.company" :value="item.userId"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="卡号类型：" prop="numberType" label-width="170px">
          <el-select v-model="ruleForm.numberType" placeholder="下拉选择ICCID/MSISDN" clearable>
            <el-option v-for="item in numberTypeOptions" :key="item.value" :label="item.label" :value="item.value" >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="ICCID/MSISDN列表：" prop="msisdns" label-width="180px">
          <template slot-scope="{}" slot="label">
            <span>ICCID/MSISDN列表：</span>
            <el-tooltip class="item" effect="dark" placement="top">
              <i class="el-icon-question" style="font-size: 14px; vertical-align: middle;"></i>
              <div slot="content">ICCID/MSISDN列表，填写多个用回车键分隔
                                <br/>进行群发短信，最多2000个</div>
            </el-tooltip>
        </template>
        <template>
          <el-input v-model="ruleForm.msisdns" type="textarea" placeholder="多个用回车键分割ICCID/MSISDN，最多2000个" rows="6" style="width:460px" ></el-input>
        </template>
      </el-form-item>

      <el-form-item label="短信模版：" prop="actionid" label-width="180px">
        <el-select v-model="ruleForm.actionid" placeholder="请选择" >
          <el-option v-for="item in smsTemplateOptions" :key="item.id" :label='item.type + "-" + item.actionId'  :value="item.actionId"
                     @click.native="selectTemplate(item)">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item v-for="(item,index) in inputArr" :key="index" label-width="180px" :label="'参数'+(index+1)+'：'" prop="description">
        <el-input v-model="params[index]" :maxlength="20" @input="changeInputParams($event,index)" placeholder="长度不超过20位字符，只支持英文、数字或符号" style="width:460px"></el-input>
      </el-form-item>

      <el-form-item label="模版内容：" prop="tip" label-width="180px">
        <template slot-scope="{}" slot="label">
          <span>模版内容：</span>
          <el-tooltip class="item" effect="dark" placement="top">
            <i class="el-icon-question" style="font-size: 14px; vertical-align: middle;"></i>
            <div slot="content">用于展示发送的短信内容，一个{数字}对应一个参数。</div>
          </el-tooltip>
        </template>
        <template>
          <el-input v-model="ruleForm.content" type="textarea" placeholder="模版内容" autosize style="width:460px" disabled></el-input>
        </template>
      </el-form-item>

      <el-form-item label-width="180px">
         <el-button type="primary" size="medium" @click="send()" v-hasPermi="['sms:center:send']">发送短信</el-button>
      </el-form-item>

    </el-form>

    <div class="cardContent marge-class">
      <el-tabs v-model="activeName" @tab-click="handleClick" v-if="checkPermi(['sms:center:sent'])">
        <el-tab-pane label="发送记录" name="sent">
          <sentList ref="sentListRef" ></sentList>
        </el-tab-pane>
        <el-tab-pane label="回复记录" name="received" v-if="checkPermi(['sms:center:received'])">
          <receivedList ref="receivedListRef"></receivedList>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import sentList from "@/components/sendSms/sentList.vue";
import receivedList from "@/components/sendSms/receivedList.vue";

import {agentList, simSmsBatchSms, simSmsSendSms, simSmsTemplateAll} from "@/api/api.js";
export default {
  name: "sendSms",
  data() {
    let checkMsisdns= (rule,value,callback) => {
      if(!value){
        return callback(new Error('请输入ICCID/MSISDN'))
      } else {
        let msisdnArr = value.trim().split(/[(\r\n)\r\n]+/);
        if(msisdnArr != null && msisdnArr.length > 2000){
          return callback(new Error('超出最大限制'))
        } else {
          return callback()
        }
      }
    }
    return {
      activeName: "sent",
      agentList: [],
      ruleForm: {
        numberType:"",
        msisdn:"",
        msisdns:"",
        actionid:null,
        content:"",
        oldContent:"",
      },
      smsTemplateOptions:[],
      numberTypeOptions:[
        {value:1,label:"ICCID"},
        {value:2,label:"MSISDN"}
      ],
      rules: {
        numberType: [
          { required: true, message: "请选择编号类型", trigger: "blur" },
        ],
        actionid: [
          { required: true, message: "请选择短信模版", trigger: "blur" }
        ],
        content: [
          { required: true, message: "请输入短信模版", trigger: "blur" },
        ],
        msisdns: [
          { required: true, validator:checkMsisdns, trigger: "blur" },
        ],
      },
      inputArr:[],
      params:[]
    };
  },
  components: {
    sentList,receivedList
  },
  computed: {
    adminShow : {
      get() {
        return this.$store.getters.user.userType =='1'
      }
    },
  },
  methods: {
    //代理商下拉列表
    queryAgentList() {
      agentList().then(res => {
        this.agentList = res.data.data;
      });
    },
    changeInputParams(value,index) {
      let content = this.ruleForm.oldContent;
      this.params.forEach(function(item,index,arr){
        let number = index+1;
        content = content.replace("{"+number+"}","{"+item+"}");
      })
      this.ruleForm.content = content;
    },
    // 发送
    send(){
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
            let msisdnArr = this.ruleForm.msisdns.trim().split(/[(\r\n)\r\n]+/);
            if(msisdnArr != null && msisdnArr.length == 1){
              this.ruleForm.msisdn = this.ruleForm.msisdns.trim();
              this.sendSms();
            } else if(msisdnArr != null && msisdnArr.length > 1){
              this.sendBatchSms();
            }
        }
      })
    },
    // 发送短信
    sendSms() {
      let data = {
        ...this.ruleForm,
      };
      this.$alert("确定要发送短信吗？", "发送短信", {
        confirmButtonText: "确定"
      }).then(() => {
        simSmsSendSms(data).then(res => {
          if (res.data.code == 200) {
            this.$notify({
              title: "成功",
              message: "发送短信成功",
              type: "success"
            });
            this.ruleForm = {};
          } else {
            this.$message.error(res.data.message);
          }
          this.$refs.sentListRef.initData();
        });
      });
    },
    // 群发短信
    sendBatchSms() {
      let data = {
        ...this.ruleForm,
      };
      this.$alert("确定要发送短信吗？", "发送短信", {
        confirmButtonText: "确定"
      }).then(() => {
        simSmsBatchSms(data).then(res => {
          if (res.data.code == 200) {
            this.ruleForm = {}
            this.$notify.info({
              title: "提示",
              message: "已提交短信发送请求，请在任务中心查看进度",
              duration: 1000,
              offset:30
            });
            setTimeout(()=>{
              this.$router.push(`/taskCenter/missionList`);
            },1000)
          } else {
            this.$message.error(res.data.message);
          }
        });
      });
    },
    // 运营商
    transferType(status){
      let obj = {
        '1': "中国电信",
        '2': "中国移动",
        '3': "中国联通",
        '4': "国际",
      };
      return obj[status];
    },
    // 获取限速速率列表
    getSmsTemplateOptions(value){
      let params ={userId:value};
      simSmsTemplateAll(params).then(res => {
        if(res.data.code == 200) {
          this.smsTemplateOptions = res.data.data;
          this.smsTemplateOptions.map((item,index)=>{
            item.type = this.transferType(item.type);
          })
        }
      });
    },
    // 选择代理商
    changeAgent(value){
      if(value !== ""){
        this.getSmsTemplateOptions(value);
      } else {
        this.smsTemplateOptions = [];
        this.$set(this.ruleForm, "actionid", null);
      }
    },
    // 选择模版
    selectTemplate(item){
      this.ruleForm.content = item.content;
      this.ruleForm.oldContent = item.content;
      let count = item.content.split(/\{[1-9]}/g).length-1;
      const inputArr = new Array(count).fill("")
      this.inputArr = inputArr;
    },
    handleClick(tab) {
      this.$router.push("/smsCenter/sendSms?msisdn=" + this.ruleForm.msisdns);
      if (tab.name == "sent") {
        this.$refs.sentListRef.initData();
      }else if(tab.name == "received"){
        this.$refs.receivedListRef.initData();
      }
    },
  },
  created() {
    if(this.adminShow){
      this.queryAgentList();
    } else {
      this.getSmsTemplateOptions(null);
    }

  },
  mounted() {

  }
};
</script>

